const PortalEvent = {
  CURRENT_DAY_PASSED: 'portalCurrentDayPassed',
  CURRENT_MONTH_PASSED: 'portalCurrentMonthPassed',
  DATEPICKERS_CHANGED_TO_TODAY: 'portalDatepickersChangedToToday',
  DIMENSIONS_CHANGED: 'portalDimensionsChanged',
  DISTRACTION_FREE_MODE_CHANGED: 'portalDistractionFreeModeToggled',
  UPDATE_REQUESTED: 'portalUpdateRequested',
};

export default PortalEvent;
